import { BrowserRouter, Routes, Route } from "react-router-dom";

import './App.css';
import Topper from "./components/Topper";
import VerifyEmail from './pages/VerifyEmail.js';
import ResetPassword from './pages/ResetPassword.js';
import NotFound from './pages/NotFound';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
// import Footer from './components/Footer.js';
import VerifyAccountDeleted from "./pages/VerifyAccountDeleted.js";
import DeleteAccount from "./pages/DeleteAccount.js";
import "./components/LangButton";


function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Topper />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/confirm-delete-account" element={<VerifyAccountDeleted />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        {/* <LangButton/> */}
        {/* <Footer /> */}
      </div>
    </BrowserRouter>
  )
}
export default App;
